module.exports = __webpack_public_path__ + "img/nb_5.fa4052d7.png";